<template>
  <v-expansion-panels style="border-radius: 0px !important">
    <v-expansion-panel>
      <v-expansion-panel-header style="border-radius: 0px !important" :style="{ 'background-color': data.DropdownButtonBGColor}">
        <center :style="{ 'color': data.DropdownButtonTextColor}">{{title}}</center>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div 
          v-for="item in items"
          :key="`dropdownButtonContent${item.ID}`"
        >
          <items
            :item="item"
            :menuID="data.ID"
            :isMobile="true"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  // import Items from '@/components/Items'
  export default {
    name: 'DropdownButton',
    components: {
      // [Vue warn]: Unknown custom element:  did you register the component correctly? For recursive components, make sure to provide the "name" option
      // https://stackoverflow.com/questions/49154490/did-you-register-the-component-correctly-for-recursive-components-make-sure-to
      Items: () => import('@/components/Items')
      // Items
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data () {
      return {
        items: null
      }
    },
    computed: {
      ...mapState('app',['locale']),
      title () {
        return this.data.DropdownButtonTitle ? utils.getTranslation (this.data.DropdownButtonTitle, this.locale) : ''
      },
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData() {
        const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
        api.getAll(`contents/dropdownButton/${this.data.ID}`, false, 1, 1000, '', enterpriseIDDomain).then(response => {
          this.items = response
        })
      }
    }
  }
</script>